import _objectWithoutProperties from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
var PortalContext = /*#__PURE__*/React.createContext(null);
var globalOverlayCounter = 0;
export function PortalProvider(props) {
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      items = _React$useState2[0],
      setItems = _React$useState2[1];

  var setOverlayItem = function setOverlayItem(item) {
    var overlayId = ++globalOverlayCounter;
    setItems(function (prev) {
      return prev.concat([{
        id: overlayId,
        node: item
      }]);
    });
    return overlayId;
  };

  var updateOverlayItem = function updateOverlayItem(id, node) {
    setItems(function (prev) {
      return prev.map(function (item) {
        if (item.id === id) {
          return {
            id: id,
            node: node
          };
        }

        return item;
      });
    });
  };

  var removeOverlayItem = function removeOverlayItem(id) {
    setItems(function (prev) {
      var newItems = prev.filter(function (item) {
        return item.id !== id;
      });
      return newItems;
    });
  };

  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: {
      items: items,
      setOverlayItem: setOverlayItem,
      removeOverlayItem: removeOverlayItem,
      updateOverlayItem: updateOverlayItem
    }
  }, props.children, items.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, item.node);
  }));
}

function OverlayView(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/React.createElement(View, _extends({
    pointerEvents: "box-none",
    style: [StyleSheet.absoluteFill, style],
    collapsable: false
  }, props));
}

export var OverlayProvider = PortalProvider;
export function OverlayContainer(props) {
  var context = usePortalProvider();
  var overlayId = React.useRef(undefined);
  var contents = /*#__PURE__*/React.createElement(OverlayView, props);
  useEffect(function () {
    // Mount
    if (overlayId.current === undefined) {
      overlayId.current = context === null || context === void 0 ? void 0 : context.setOverlayItem(contents);
    } // Update
    else {
      if (overlayId.current) {
        context === null || context === void 0 ? void 0 : context.updateOverlayItem(overlayId.current, contents);
      }
    }
  }, // To re-render the child
  [props]); // Unmount

  useEffect(function () {
    return function () {
      if (overlayId.current) {
        context === null || context === void 0 ? void 0 : context.removeOverlayItem(overlayId.current);
      }
    };
  }, []);
  return null;
}

function usePortalProvider() {
  var context = React.useContext(PortalContext);
  return context;
}